"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _nanoid = require("nanoid");
var _types = _interopRequireDefault(require("./types"));
var _getColorStops = _interopRequireDefault(require("./utils/get-color-stops"));
var QuantityStatus = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var quantity = _ref.quantity,
    svgIds = _ref.svgIds,
    children = _ref.children,
    isPlusShown = _ref.isPlusShown;
  var colorStops = (0, _getColorStops["default"])(quantity);
  var uuid = (0, _nanoid.nanoid)();
  var linerGradientId = "linear_gradient_".concat(uuid);
  var maskId = "mask_".concat(uuid);
  var svgCount = quantity.length;
  var width = "".concat(100 / svgCount, "%");
  var viewBoxWidthMultiplier = isPlusShown ? svgCount + 1 : svgCount;
  var svgWidth = 18;
  var viewBox = "0 0 ".concat(svgWidth * viewBoxWidthMultiplier, " 16");
  var baseTranslate = 1;
  var bothAvailable = quantity.filter(function (val) {
    return val !== 'n/a';
  }).length === 2;
  var gradientUnits = bothAvailable ? 'userSpaceOnUse' : 'objectBoundingBox';
  var getUseMap = function getUseMap(condition) {
    return quantity.map(function (value, index) {
      var extraTranslateValue = isPlusShown ? index * 0.5 * svgWidth * (svgCount + 1) : index * svgWidth;
      var translateValue = "translate(".concat(baseTranslate + extraTranslateValue, ")");
      var useHref = "#".concat(svgIds[index]);
      if (condition(value)) {
        var key = "".concat(value).concat(index);
        return /*#__PURE__*/_react["default"].createElement("use", {
          key: key,
          href: useHref,
          transform: translateValue
        });
      }
      return null;
    });
  };
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: "100%",
    height: "100%",
    viewBox: viewBox
  }, /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("rect", {
    id: "rect",
    mask: "url(#".concat(maskId, ")"),
    fill: "url(#".concat(linerGradientId, ")"),
    width: width,
    height: "100%"
  }), children, /*#__PURE__*/_react["default"].createElement("linearGradient", {
    id: linerGradientId,
    gradientUnits: gradientUnits
  }, colorStops.map(function (item, index) {
    var stopColor = item.stopColor,
      offset = item.offset;
    var key = "".concat(stopColor).concat(offset).concat(index);
    return /*#__PURE__*/_react["default"].createElement("stop", {
      key: key,
      stopColor: stopColor,
      offset: offset
    });
  })), /*#__PURE__*/_react["default"].createElement("mask", {
    id: maskId,
    fill: "#fff"
  }, getUseMap(function (value) {
    return value !== 'n/a';
  }))), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "url(#".concat(linerGradientId, ")"),
    mask: "url(#".concat(maskId, ")")
  }, quantity.map(function (value, index) {
    var rectX = index * svgWidth;
    return /*#__PURE__*/_react["default"].createElement("rect", {
      key: rectX,
      x: rectX,
      y: "0",
      width: width,
      height: "100%"
    });
  })), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "transparent",
    stroke: "#c2c5cc"
  }, getUseMap(function (value) {
    return value === 'n/a';
  })));
});
QuantityStatus.displayName = 'QuantityStatus';
QuantityStatus.propTypes = {
  quantity: _propTypes["default"].arrayOf(_propTypes["default"].oneOf(_types["default"])).isRequired,
  svgIds: _propTypes["default"].arrayOf(_propTypes["default"].oneOf(['plane', 'hotel'])).isRequired,
  children: _propTypes["default"].node.isRequired
};
var _default = exports["default"] = QuantityStatus;